import { Controller } from "@hotwired/stimulus"

// Handles optimistic UI for confidence button clicks
export default class extends Controller {
  submit(event) {
    // The button_to form handles submission via Turbo Stream.
    // This controller can be extended for optimistic UI if needed.
  }
}
